<script>
import VueCookies from "vue-cookies";
import { CategoryService } from "@/services/nextshop/category.service";
import { StoreMerchantService } from "@/services/nextshop/storeMerchant.service";
import { PackageService } from "@/services/nextshop/package.service";

/**
 * Products component
 */
export default {
  name: "product-list",
  data() {
    return {
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      title: "GIAN HÀNG TRỰC TUYẾN",
      idCheck: '',
      loading: false,
      filter: false,
      isCreatStore: false,
      isCreatProduct: false,
      isShowDataProduct: false,
      isListProduct: false,
      notAllow: false,

      dataProductStore: [],
      inforStore: {},
      inforAccount: JSON.parse(localStorage.getItem("auth.currentUser")),
      inforMerchant: JSON.parse(localStorage.getItem("auth.currentMerchant")),
      merchantId: "",
      // pagination
      perPage: 15,
      currentPage: 1,
      textSearch: "",
      dataLastIndex: [],
      category: [],

      search: {
        queryString: "",
        merchantId: VueCookies.get('MID'),
        pagingAndSorting: {
          limit: 100,
          lastIndex: "",
          sortOrder: "DESC",
        },
      },
      categoryId: { nin: [] },
      variationIsChose: new Object(),
    };
  },

  async created() {
    try {
      this.loading = true;
      await this.listCategory();
      await this.getInforMerchant();
    } catch (error) {
      console.log(error);
    }
  },

  methods: {
    // check store
    async getInforMerchant() {
      try {
        this.loading = true;
        const responseAliasNam = await StoreMerchantService.getMerchantAliasName(
          this.inforMerchant.aliasName
        );

        const params = responseAliasNam.data.length === 0
          ? {
            merchantId: VueCookies.get('MID'),
            locationId: this.inforAccount.locationInfos[0].id
          }
          : {
            merchantId: responseAliasNam.data[0].coMerchantId,
            locationId: responseAliasNam.data[0].coLocationId,
          }
        const response = await StoreMerchantService.getInforMerchant(params);

        if (response.success) {
          this.inforStore = response.data;
          await this.fetchData();
        } else {
          await this.checkAllowing();
          if(this.notAllow) {
            this.isCreatStore = false;
            this.loading = false;
          } else {
            this.isCreatStore = true;
            this.loading = false;
          }
        }
      } catch (error) {
        console.error(error);
      }
    },

    async checkAllowing() {
      try {
        const res = await PackageService.checkMerchantHasAllowing('online-store');
        if(res.success) {
          if(!res.data.allowable) {
            this.notAllow = true
          }
        }
      } finally {
      }
    },

    // Get list Merchant
    async fetchData() {
      try {
        this.merchantId = VueCookies.get('MID');
        const response = await StoreMerchantService.getListProduct(
          this.search
        );

        if (response.data.length === this.search.pagingAndSorting.limit) {
          this.search.pagingAndSorting.limit += 100;
          this.fetchData();
        }
        if (response.data) {
          response.data.map((f) => {
            const arrVariations = f.variations
            let exportPriceMin = 0
            let exportPriceMax = 0
            arrVariations.map((variation, _index) => {
              // Get quantity
              variation = this.getStockQuantityVari(variation)
              if(variation.stockQuantities.length > 0) {
                f.quantity = variation.stockQuantities[0].inventoryDatas[0].quantity
              } else {
                f.quantity = 0
              }

              variation.unit = f.unit.name

              const getPriceItem = variation.prices.find(price => price.priceTypeCode === 'PRICE_EXPORT')
              if(getPriceItem != undefined){
                const tmpPrice = this.divisionThousand(getPriceItem.amount)
                if(_index == 0){
                  exportPriceMin = tmpPrice
                  exportPriceMax = tmpPrice
                }else{
                  if(exportPriceMin > tmpPrice){
                    exportPriceMin = tmpPrice
                  }
                  if(exportPriceMax < tmpPrice){
                    exportPriceMax = tmpPrice
                  }
                }
              }
            })
            f.prices[0] = exportPriceMin
            f.prices[1] = exportPriceMax
          });

          this.dataProductStore = response.data;

          if (this.dataProductStore.length === 0 && !this.filter == true) {
            this.isCreatProduct = true;
          } else {
            this.isShowDataProduct = true;
          }
          this.isListProduct = true;
          this.loading = false;
        }
      } catch (error) {
        console.error(error);
      }
    },

    // Get list Category - CategorySub
    async listCategory() {
      const searchCategory = {
        queryString: { parentId: { eq: "" } },
        sort: "-id",
        lastItem: "",
        limit: 100,
      };
      const searchSub = {
        queryString: { parentId: { ne: "" } },
        sort: "-id",
        lastItem: "",
        limit: 50,
      };
      const response = await CategoryService.getList({
        ...searchCategory,
        merchantId: this.merchantId
      });
      const res = await CategoryService.getList({
        ...searchSub,
        merchantId: this.merchantId
      });
      if (response.data) {
        const datas = [];
        response.data.map((e) => {
          let sub = [];
          const body = {
            id: e.id,
            name: e.name,
          };
          res.data.map((e) => {
            if (e.parentId === body.id) {
              sub.push({ name: e.name, id: e.id });
            }
          });
          body.sub = sub;
          datas.push(body);
        });
        res.data.map((e) => {
          this.categoryId.nin.push(e.id);
        });
        this.category = datas;
        // this.category.push({ id: 0, name: "Danh mục khác" });
      }
    },

    async filterProduct(data) {
      try {
        this.loading = true;
        this.filter = true;
        this.idCheck = data.id

        if (data.sub !== undefined && data.sub.length > 0) {
          this.search.queryString = `{metaSearchable.rootCateId}=='''${data.id}'''`
        } else if(data.sub == undefined) {
          this.search.queryString = `{category.categoryId}in['''${data.id}''']`
        }

        await this.fetchData();
      } catch (error) {
        console.log(error);
      }
    },

    toLinkStoreOnline() {
      window.open(`${process.env.VUE_APP_STORE_ONLINE}/store/${this.inforMerchant.aliasName}`, "_blank");
    },

    // Copy URL to clipboard
    copyURL() {
      navigator.clipboard.writeText(`${process.env.VUE_APP_STORE_ONLINE}/store/${this.inforMerchant.aliasName}`);
      this.$bvToast.toast(`Sao chép liên kết thành công!`, {
          title: `Thông báo`,
          autoHideDelay: `1000`,
          variant: `success`,
          toaster: `b-toaster-top-center`,
          solid: true,
          appendToast: true,
      });
    },

    // link to creat store
    toCreatStore() {
      this.$router.push({
        name: "Hướng dẫn tạo gian hàng trực tuyến",
        component: () => import("@/pages/store-merchant/create-store-instruction"),
        params: { note: "Link_From_Store" },
      });
    },
  },

  computed: {
    paginatedProducts() {
      const { currentPage, perPage } = this;
      const start = (currentPage - 1) * perPage;
      const end = currentPage * perPage;

      return this.dataProductStore.slice(start, end);
    },
    rows() {
      return this.dataProductStore.length;
    },
  },
};
</script>

<template>
  <TheLayout>
    <div v-if="dataPermission && dataPermission.includes('NSH_ONLINE_STORE_VIEW')">
      <div class="box-loading" v-if="loading">
        <div class="loading">
          <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-flex align-items-center justify-content-between">
            <h4 class="font-weight-bold">{{title}}</h4>
            <div class="page-title-right">
              <b-button variant="primary"
                @click="$router.push('/items')"
                v-if="dataPermission && dataPermission.includes('NSH_ITEM_PROD_VIEW')">
                  <i class="bx bx-box font-size-16 align-middle mr-2"></i>
                  Quản lý sản phẩm
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="notAllow">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <div class="text-center">
                  <div class="row justify-content-center">
                    <div class="row justify-content-center mt-5 mb-2">
                      <div class="col-sm-12">
                        <div>
                          <img style="width:200px;height:200px;" src="@/assets/images/store-allowing.png" alt class="img-fluid"/>
                        </div>
                      </div>
                    </div>

                    <div style="text-align: -webkit-center;" class="col-lg-10 mb-5">
                      <h3 style="font-weight: 600 !important;color: #23313E;" class="mt-4 font-weight-semibold">Tính năng cần nâng cấp lên gói NextShop mới</h3>

                      <div class="mt-4">
                        <div style="color: #808890;text-align: center;width: 462px;font-size: 14px;">Gói NextShop của bạn không hỗ trợ tính năng Gian hàng trực tuyến. Vui lòng nâng cấp gói để sử dụng tính năng này</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isCreatStore">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <div class="text-center">
                  <div class="row justify-content-center">
                    <div class="row justify-content-center mt-5 mb-2">
                      <div class="col-sm-12">
                        <div>
                          <img src="@/assets/images/store-bg.svg" alt class="img-fluid"/>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-10">
                      <h4 class="mt-4 font-weight-semibold">Bạn chưa tạo gian hàng trực tuyến</h4>

                      <div class="mt-4">
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="toCreatStore"
                          v-if="dataPermission && dataPermission.includes('NSH_ONLINE_STORE_SETTING')">
                          Tạo ngay gian hàng trực tuyến
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isListProduct">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <div class="media store-header-info">
                  <div class="mr-3">
                    <img v-if="inforStore.logoUrl === ''" src="../../assets/images/noImg.png" alt class="avatar-md img-thumbnail"/>
                    <img v-else :src="inforStore.logoUrl" alt class="avatar-md img-thumbnail"/>
                  </div>
                  <div class="media-body align-self-center">
                    <div class="text-muted">
                      <h5><b>{{ inforStore.coMerchantName }} - {{ inforStore.storeName }}</b></h5>
                      <p class="mb-1">{{ inforStore.description }}</p>
                    </div>
                    <div class="mt-2">
                      <b-button
                        variant="outline-primary"
                        size="sm"
                        class="btn-primary-custom mr-2"
                        @click="copyURL()">
                        <i class="bx bx-share-alt"></i> Sao chép liên kết
                      </b-button>
                      <b-button
                        variant="outline-primary"
                        size="sm"
                        class="btn-primary-custom"
                        @click="toLinkStoreOnline">
                        <i class="bx bx-store-alt"></i> Xem Shop
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3" v-if="isCreatProduct">
          <div class="col-12 d-flex flex-column align-items-center align-content-center my-5">
            <img src="@/assets/images/Update-cuate.png" style="height: 334px; width: 500px"/>
            <h4>Gian hàng chưa có sản phẩm</h4>
            <button class="btn btn-primary"
            v-if="dataPermission && dataPermission.includes('NSH_ITEM_PROD_CREATE')"
            @click="$router.push('/pro-add')">Thiết lập sản phẩm ngay
            </button>
          </div>
        </div>

        <div v-if="isShowDataProduct">
          <div class="row">
            <div class="col-lg-3">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title mb-4" style="font-weight: bold !important">Lọc sản phẩm</h4>

                  <div v-for="(item, index) in category" :key="index">
                    <a href="javascript: void(0);" @click="filterProduct(item)">
                      <h5 class="font-size-14 mb-3 text-truncate" style="font-weight: bold !important" :class="(idCheck === item.id) ? 'active' : ''">
                        {{ item.name }}
                      </h5>
                    </a>
                    <ul class="list-unstyled product-list">
                      <li v-for="(subItem, index_sub) in item.sub" class="text-truncate" :key="index_sub" @click="filterProduct(subItem)">
                        <div>
                          <a class="item" href="javascript: void(0);" :class="(idCheck === subItem.id) ? 'active' : ''" >
                            <i class="mdi mdi-chevron-right mr-1"></i>
                            {{ subItem.name }}
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-9 mc-product-list-content" 
              v-if="paginatedProducts.length == 0">
              <div class="row">
                <div class="col-12 d-flex flex-column align-items-center align-content-center my-5">
                    <img src="@/assets/images/Update-cuate.png" style="height: 334px; width: 500px"/>
                    <h4>Gian hàng chưa có sản phẩm</h4>
                  </div>
              </div>
            </div>

            <div class="col-lg-9 mc-product-list-content" v-else>
              <div class="bgWhite">
                <div class="row">
                  <div
                    v-for="data in paginatedProducts"
                    :key="data.itemId"
                    class="col-xl-3 col-sm-5">
                    <div class="card">
                      <router-link tag="a" :to="`/store-merchant/product-detail/${data.itemId}`">
                      <div class="product-img position-relative">
                            <img v-if="data.images.length === 0 || data.images[0] == ''"
                              style="width:250px; height: 250px; object-fit: cover;" 
                              class="img-fluid mx-auto d-block" 
                              src="@/assets/images/no-img.png"/>
                            <img
                              v-else
                              :src="`${data.images[0]}`"
                              alt
                              style="width:250px; height: 250px; object-fit: cover;" 
                              class="img-fluid mx-auto d-block"
                            />
                        </div>
                        <div class="mb-1">
                          <h5 class="mb-1 text-truncate prod-title">
                            {{ data.name }}
                          </h5>
                          <h5 class="mb-1">
                            <div class="d-flex justify-content-between">
                              <span class="productList-price text-bold text-red">{{formatMoney(data.prices[0])}}</span>
                            </div>
                          </h5>
                          <h5 class="my-0">
                            <p v-if="data.quantity > 0" class="productList-price my-0">
                            SL: {{data.quantity}}
                            </p>
                            <p v-else class="productList-price my-0">
                            Hết hàng
                            </p>
                          </h5>
                        </div>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end row -->

              <div class="row">
                <div class="col-lg-12">
                  <b-pagination
                    class="justify-content-center"
                    v-model="currentPage"
                    v-show="dataProductStore.length > 0"
                    pills
                    hide-goto-end-buttons
                    :total-rows="rows"
                    :per-page="perPage"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NotPermission v-else></NotPermission>
  </TheLayout>
</template>
<style lang="scss" scoped>
.item {
  &:hover {
    color: #1f3dd0 !important;
    cursor: pointer;
  }

}

.active {
  color: #1f3dd0 !important;
  cursor: pointer;
}
</style>